function view (path) {
  return () => import(/* webpackChunkName: '' */ '@/views/sra/' + path).then(m => m.default || m) // eslint-disable-line prefer-template
}

const sraRoutes = [
  {
    path: '/sra/dashboard',
    component: view('Dashboard'),
    name: 'sra.dashboard',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Dashboard',
          active: true
        }
      ]
    }
  },
  {
    path: '/sra/sales-order',
    component: view('SalesOrder'),
    name: 'sra.sales-order',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Sales Order',
          active: true
        }
      ]
    }
  },
  {
    path: '/sra/sales-order-tracker/:status?',
    component: view('SalesOrderTracker'),
    name: 'sra.sales-order-tracker',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Sales Order Tracker',
          active: true
        }
      ]
    }
  }
]

export default sraRoutes
